export default function digCapture(key) {
  return window._app?.widget?.capture(key)
}
